export default __webpack_public_path__ + "static/media/warning-orange.97e3ec14.svg";